<script>
  import { onMount } from "svelte";
  import { api } from "../../../../../helpers";
  import { addToast } from "../../../../custom/Toasts/store";
  import { push } from "svelte-spa-router";
  import { preview_image, publication_items } from "./store";

  import GeneralLayout from "../../../../layouts/GeneralLayout.svelte";
  import Accordion from "./components/Accordion/Accordion.svelte";
  import CheckboxField from "./components/CheckboxField/CheckboxField.svelte";
  import PublicationItems from "./components/PublicationItems/PublicationItems.svelte";
  import FileForm from "./components/FileForm/FileForm.svelte";
  import Input from "./components/Input/Input.svelte";
  import Select from "./components/Select/Select.svelte";
  import Button from "../../components/Button/Button.svelte";
  import FlowSelect from "./components/FlowSelect/FlowSelect.svelte";
  import LayoutLoader from "../../../../custom/LayoutLoader.svelte";

  export let params = {};

  let isLoadingData = true;

  let createModel = {
    title: "",
    preview_text: "",
    feed_group: null,
    feed_tags: [],
    flow_program_page: null,
    flows: [],
    hidden_for_flows: [],
    language: { pk: "ru", title: "Русский" },
    section: null,
    wiki_page: null,
    read_time: "",
    disable_comments: false,
    disable_pushs: false,
    additional_content: false,
  };

  let errorFields = {
    title: false,
  };

  let selectData = null;

  const getSelectData = async () => {
    const response = await api("/api/v1/publication-editor/params/");
    const data = await response.json();
    return data;
  };

  const getPublication = async (publicationId) => {
    const response = await api(
      `/api/v1/publication-editor/publication/retrive/${publicationId}/`
    );
    const data = await response.json();
    return data;
  };

  const serializeFields = (model) => {
    return {
      title: model.title,
      preview_text: model?.preview_text,
      language: model?.language?.pk,
      section: model?.section?.pk || null,
      disable_comments: model.disable_comments,
      disable_pushs: model.disable_pushs,
      additional_content: model.additional_content,
      read_time: model.read_time || 0,
      feed_group: model?.feed_group?.pk || null,
      flow_program_page: model?.flow_program_page?.pk || null,
      wiki_page: model?.wiki_page?.pk || null,
      feed_tags: model?.feed_tags?.map((item) => item.pk || item),
      flows: model?.flows?.map((item) => item.pk || item),
      hidden_for_flows: model?.hidden_for_flows?.map((item) => item.pk || item),
      preview_image: $preview_image,
      publication_items: $publication_items.map((item, sort) => ({
        ...item,
        sort,
      })),
    };
  };

  const updatePublication = async () => {
    if (!createModel.title.length) {
      errorFields.title = true;
      addToast("Заполни обязательные поля");
      return;
    }

    const { ok } = await api(
      `/api/v1/publication-editor/publication/update/${params.id}/`,
      "PUT",
      JSON.stringify(serializeFields(createModel)),
      true
    );

    if (!ok) {
      return;
    }

    addToast("Публикация успешно обновлена", "success");
    push("/editor/list");
  };

  const create = async () => {
    if (!createModel.title.length) {
      errorFields.title = true;
      addToast("Заполни обязательные поля");
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return;
    }

    const response = await api(
      "/api/v1/publication-editor/publication/create/",
      "POST",
      JSON.stringify(serializeFields(createModel)),
      true
    );

    if (!response.ok) {
      return;
    }

    addToast("Публикация успешно создана", "success");
    push("/editor/list");
  };

  $: if (createModel.title) {
    errorFields.title = false;
  }

  const changeFlows = (event) => {
    if (event.detail && !event.detail.length) {
      createModel.flows = event.detail;
      return;
    }

    const cyrillicRegularExpression = /^[?!,./а-яА-ЯёЁ0-9\s]+$/i;
    const isOnlyCyrillic = cyrillicRegularExpression.test(
      createModel.flows[0]?.title
    );

    createModel.language = isOnlyCyrillic
      ? { pk: "ru", title: "Русский" }
      : { pk: "en", title: "Английский" };
  };

  const formatPublicationItemsToFront = (publicationItems) => {
    return publicationItems.map((item) => {
      const result = {
        id: item.id,
        sort: item.sort,
        item_type: item.item_type,
      };

      if (item.video_url) {
        result.video_url = item.video_url;
      }

      if (item.video_url_2) {
        result.video_url_2 = item.video_url_2;
      }

      if (item.audio_url) {
        result.audio_url = item.audio_url;
      }

      if (item.doc) {
        result.doc = item.doc;
      }

      if (item.text) {
        result.text = item.text;
      }

      if (item.image) {
        result.image = item.image;
      }

      return result;
    });
  };

  const setPublication = async (publicationId) => {
    const data = await getPublication(publicationId);

    createModel.title = data.title;
    createModel.preview_text = data.preview_text;
    createModel.disable_comments = data.disable_comments;
    createModel.disable_pushs = data.disable_pushs;
    createModel.additional_content = data.additional_content;
    createModel.read_time = data.read_time;
    createModel.flows = selectData.flows.filter((flow) =>
      data.flows.some((pk) => flow.pk === pk)
    );
    createModel.hidden_for_flows = selectData.flows.filter((flow) =>
      data.hidden_for_flows.some((pk) => flow.pk === pk)
    );
    createModel.feed_tags = selectData.feed_tag.filter((item) =>
      data.feed_tags.some((pk) => item.pk === pk)
    );
    createModel.language =
      data.language === "en"
        ? { pk: "en", title: "Английский" }
        : { pk: "ru", title: "Русский" };
    createModel.feed_group = selectData.feed_group.find(
      (group) => group.pk === data.feed_group
    );
    createModel.flow_program_page = selectData.flow_program_page.find(
      (item) => item.pk === data.flow_program_page
    );
    createModel.wiki_page = selectData.wiki_page.find(
      (item) => item.pk === data.wiki_page
    );
    createModel.section = selectData.publicate_section.find(
      (item) => item.pk === data.section
    );

    $publication_items = formatPublicationItemsToFront(data.publication_items);

    $preview_image = data.preview_image || { base64: "", name: "" };
  };

  onMount(async () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    $publication_items = [];

    selectData = await getSelectData();

    const publicationId = params.id;

    if (publicationId) {
      await setPublication(publicationId);
    }

    isLoadingData = false;
  });
</script>

<GeneralLayout isEditor>
  <div class="back-button" on:click={() => push("/editor/list")}>
    <i class="icon-arrow-up" />
    <div class="text">Назад</div>
  </div>

  <div class="title">Создание поста</div>

  <Input
    bind:value={createModel.title}
    placeholder="Заполни тут..."
    title="Заголовок поста"
    required
    isError={errorFields.title}
  />

  <Input
    bind:value={createModel.preview_text}
    placeholder="Заполни тут..."
    title="Текст превью"
    type="textarea"
    tooltip="Это текст, который видно в Ленте"
  />

  <FileForm />

  <div class="editor-title">Наполнение поста</div>

  <PublicationItems />

  <Accordion title="Параметры отображения поста">
    <div class="wrapper">
      <Select
        bind:value={createModel.section}
        title="Раздел"
        items={selectData.publicate_section}
      />

      <Select
        bind:value={createModel.feed_group}
        title="Группа"
        items={selectData.feed_group}
      />

      <Select
        bind:value={createModel.wiki_page}
        title="Вкладка Wiki"
        items={selectData.wiki_page}
      />

      <FlowSelect
        bind:value={createModel.flows}
        title="Потоки"
        items={selectData.flows}
        on:change={changeFlows}
      />

      <FlowSelect
        bind:value={createModel.hidden_for_flows}
        title="Скрыть для потоков"
        items={selectData.flows}
      />

      <Select
        bind:value={createModel.flow_program_page}
        title="Вкладка программы потока"
        items={selectData.flow_program_page}
      />

      <Select
        bind:value={createModel.feed_tags}
        title="Тэги"
        type="checkbox"
        items={selectData.feed_tag}
      />
    </div>
  </Accordion>

  <Accordion title="Параметры поста">
    <div class="wrapper">
      <Select
        bind:value={createModel.language}
        title="Язык публикации"
        items={selectData.language}
      />

      <Input
        bind:value={createModel.read_time}
        placeholder="Заполни тут..."
        title="Время на просмотр/чтение (мин.)"
        isOnlyNumbers
      />
    </div>

    <CheckboxField
      bind:value={createModel.disable_comments}
      label="Отключить комментарии"
    />
    <CheckboxField
      bind:value={createModel.disable_pushs}
      label="Отключить пуш-уведомление о посте"
    />
    <CheckboxField
      bind:value={createModel.additional_content}
      label="Дополнительный контент"
    />
  </Accordion>

  <div class="create-button-wrapper">
    <Button
      label="Cохранить"
      on:click={params.id ? updatePublication : create}
    />
  </div>
</GeneralLayout>

{#if isLoadingData}
  <LayoutLoader />
{/if}

<style lang="scss">
  .back-button {
    border-radius: 30px;
    padding: 6px 12px 6px 12px;
    font-weight: 600;
    line-height: 20px;
    color: #5a5f6d;
    border: 2px solid #e0e8f6;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    cursor: pointer;

    i {
      transform: rotate(-90deg);
      font-size: 12px;
      margin-right: 10px;
    }
  }

  .create-button-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 56px;
  }

  .title {
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: 0em;
    color: #30333d;
    margin-bottom: 24px;
  }

  .editor-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    color: #30333d;
    margin-bottom: 16px;
  }

  .wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0 16px;
  }
</style>
